var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cemetery-sectors-list", attrs: { id: _vm.dataParent } },
    _vm._l(_vm.value, function (item, idx) {
      return _c("CemeterySectorItem", {
        key: `cemetery-sector-item-${idx}`,
        attrs: {
          value: item,
          cemeteryCode: _vm.cemeteryCode,
          panelCfg: _vm.panelCfg,
          additional: _vm.additional,
          baseTranslateID: _vm.baseTranslateID,
          enableViewDetail: _vm.allowViewDetail,
          enableViewOnMap: _vm.allowViewOnMap,
          enableViewOccupation: _vm.allowViewOccupation,
        },
        on: { viewDetail: _vm.onViewDetail, viewOnMap: _vm.onViewOnMap },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }